import type { AnalyticsQueryFilters } from "@sales-ops-amplify/shared";

const PRESETS: Array<{ id: string; label: string; days?: number }> = [
  { id: "7d", label: "Last 7 days", days: 7 },
  { id: "28d", label: "Last 28 days", days: 28 },
  { id: "90d", label: "Last 90 days", days: 90 },
  { id: "all", label: "All time" },
];

function daysAgoIso(days: number): string {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() - days);
  d.setUTCHours(0, 0, 0, 0);
  return d.toISOString();
}

export function AnalyticsDateFilter({
  value,
  onChange,
}: {
  value: AnalyticsQueryFilters;
  onChange: (next: AnalyticsQueryFilters) => void;
}) {
  const active = (() => {
    if (!value.dateFrom) return "all";
    const from = new Date(value.dateFrom).getTime();
    for (const p of PRESETS) {
      if (!p.days) continue;
      const target = new Date(daysAgoIso(p.days)).getTime();
      if (Math.abs(from - target) < 36e5 * 12) return p.id;
    }
    return "custom";
  })();

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs text-muted-foreground">Date range</span>
      <div className="flex flex-wrap gap-1">
        {PRESETS.map((p) => (
          <button
            key={p.id}
            type="button"
            onClick={() =>
              onChange(
                p.days
                  ? { ...value, dateFrom: daysAgoIso(p.days), dateTo: undefined }
                  : { ...value, dateFrom: undefined, dateTo: undefined },
              )
            }
            className={
              active === p.id
                ? "rounded-md bg-brand/10 px-2.5 py-1 text-xs font-medium text-brand"
                : "rounded-md px-2.5 py-1 text-xs text-muted-foreground hover:bg-muted/40 hover:text-foreground"
            }
          >
            {p.label}
          </button>
        ))}
      </div>
      <label className="flex items-center gap-1.5 text-xs text-muted-foreground">
        From
        <input
          type="date"
          className="rounded border border-border bg-background px-2 py-1 text-xs text-foreground"
          value={value.dateFrom ? value.dateFrom.slice(0, 10) : ""}
          onChange={(e) =>
            onChange({
              ...value,
              dateFrom: e.target.value
                ? new Date(e.target.value).toISOString()
                : undefined,
            })
          }
        />
      </label>
      <label className="flex items-center gap-1.5 text-xs text-muted-foreground">
        To
        <input
          type="date"
          className="rounded border border-border bg-background px-2 py-1 text-xs text-foreground"
          value={value.dateTo ? value.dateTo.slice(0, 10) : ""}
          onChange={(e) =>
            onChange({
              ...value,
              dateTo: e.target.value
                ? new Date(`${e.target.value}T23:59:59.999Z`).toISOString()
                : undefined,
            })
          }
        />
      </label>
    </div>
  );
}

export function defaultAnalyticsFilters(): AnalyticsQueryFilters {
  return { dateFrom: daysAgoIso(28) };
}
